import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import EBasicActions from '@/enums/EBasicActions';
import { PrivateRoute } from '@/hooks/useAuth';

const CreateQuotePage = lazy(() => import('@/containers/Views/Quotes/CreateQuotePage'));
const EditQuotePage = lazy(() => import('@/containers/Views/Quotes/EditQuotePage'));
const QuotePage = lazy(() => import('@/containers/Views/Quotes/QuotePage'));
const QuoteDetailPage = lazy(() => import('@/containers/Views/Quotes/QuoteDetailPage'));

const QuoteRouter = (
  <Route path="quotes">
    <Route
      index 
      element={(
        <PrivateRoute 
          pageName={EPage.Quotes} 
          permissions={EBasicActions.Find}
        >
          <QuotePage />
        </PrivateRoute>
      )} 
    />
    <Route 
      path="new" 
      element={(
        <PrivateRoute 
          pageName={EPage.Quotes} 
          permissions={EBasicActions.Create}
        >
          <CreateQuotePage />
        </PrivateRoute>
      )}
    />
    <Route 
      path=":quoteId" 
      element={(
        <PrivateRoute 
          pageName={EPage.Quotes} 
          permissions={EBasicActions.Find}
        >
          <QuoteDetailPage />
        </PrivateRoute>
      )} 
    />
    <Route 
      path="edit/:quoteId" 
      element={(
        <PrivateRoute 
          pageName={EPage.Quotes} 
          permissions={EBasicActions.Edit}
        >
          <EditQuotePage />
        </PrivateRoute>
      )} 
    />
  </Route>
);

export default QuoteRouter;
